import React, { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2, CheckCircle2 } from "lucide-react";
import api from "../lib/api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) { setErr("Hasła muszą być identyczne."); return; }
    if (password.length < 8) { setErr("Hasło musi mieć min. 8 znaków."); return; }

    setErr(""); setLoading(true);
    try {
      await api.post("/participants/reset-password", { token, password });
      setSuccess(true);
      setTimeout(() => navigate("/wejscie"), 3000);
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Błąd podczas resetowania hasła.");
    } finally { setLoading(false); }
  };

  if (!token) return <div className="min-h-screen bg-[#2A2A2A] flex items-center justify-center p-5 text-white">Błędny link resetujący.</div>;

  return (
    <div className="min-h-screen bg-[#2A2A2A] flex items-center justify-center p-5">
      <div className="bg-[#1F1F1F] border border-[#3a3a3a] p-8 md:p-12 max-w-md w-full">
        {success ? (
          <div className="text-center">
            <CheckCircle2 size={64} className="text-[#FFCC00] mx-auto mb-6" />
            <h1 className="font-display text-white text-3xl uppercase mb-4">Hasło zmienione!</h1>
            <p className="text-white/60">Zaraz zostaniesz przekierowany do strony logowania.</p>
          </div>
        ) : (
          <>
            <div className="kicker mb-3">Resetowanie hasła</div>
            <h1 className="font-display text-white text-3xl uppercase mb-6">Ustaw nowe <span className="text-[#FFCC00]">hasło</span></h1>
            
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="font-mono-acc text-[10px] uppercase text-white/60">Nowe hasło</label>
                <input 
                  type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
                  className="w-full mt-2 bg-[#2A2A2A] border border-[#3a3a3a] text-white px-4 py-3 focus:border-[#FFCC00] outline-none"
                />
              </div>
              <div>
                <label className="font-mono-acc text-[10px] uppercase text-white/60">Powtórz hasło</label>
                <input 
                  type="password" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                  className="w-full mt-2 bg-[#2A2A2A] border border-[#3a3a3a] text-white px-4 py-3 focus:border-[#FFCC00] outline-none"
                />
              </div>
              
              {err && <div className="text-red-400 text-sm">{err}</div>}
              
              <button type="submit" disabled={loading}
                className="w-full bg-[#FFCC00] text-[#2A2A2A] font-display py-4 btn-brutal disabled:opacity-50 inline-flex items-center justify-center gap-2">
                {loading ? <Loader2 size={18} className="animate-spin" /> : <ShieldCheck size={18}/>} ZMIEŃ HASŁO
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
